module.exports = __webpack_public_path__ + "static/fredrick-e876b756f64c370cdcd1d1b5b5e16002.jpg";